import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Button from '@material-ui/core/Button'

/**
 *
 * @author Huong Nguyen
 */

// buttons props which accepts an array of objects
// representing each button to be rendered in the dialog box
// example:
// const buttons = [  { text: 'Cancel', onClick: () => cancelOffer() }, ... ]

function DialogBox({
  classes,
  isOpen,
  onClose,
  title,
  content,
  buttons,
  showCloseButton
}) {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      BackdropProps={{
        classes: {
          root: classes.root
        },
        style: { backgroundColor: 'rgba(0, 0, 0, 0.1)' }
      }}
    >
      <DialogTitle id="alert-dialog-title">
        <div style={{ position: 'absolute', top: 0, right: 0 }}>
          {showCloseButton && (
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={onClose}
            >
              <CloseIcon />
            </IconButton>
          )}
        </div>
        <div>
          <span style={{ fontSize: '20px' }}>{title}</span>
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <span style={{ fontSize: '15px' }}>{content}</span>
        </DialogContentText>
      </DialogContent>
      {buttons && buttons.length > 0 && (
        <DialogActions>
          {buttons.map((button, index) => (
            <Button
              key={index}
              variant={button.variant}
              className={classes.button}
              onClick={button.onClick}
            >
              {button.text}
            </Button>
          ))}
        </DialogActions>
      )}
    </Dialog>
  )
}

export default DialogBox
